import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installCsrfFetchInterceptor } from './lib/csrf';
import './index.css';

// B5-3: intercept fetch globally so state-changing calls to /api/*
// auto-carry the CSRF double-submit token. Must run before the first
// component mounts (any auth-me / list-widgets kickoff happens inside
// React effects, which fire after this line). See lib/csrf.ts.
function start() {
  installCsrfFetchInterceptor();
  const root = document.getElementById('root');
  if (!root) throw new Error('#root element not found');
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

// V98-3 review harness: dev-only canned API (src/dev/fixtures.ts). In a
// production build `import.meta.env.DEV` is false, so this branch and the
// fixtures chunk are dropped.
if (import.meta.env.DEV && import.meta.env.VITE_FIXTURES === '1') {
  void import('./dev/fixtures').then((m) => { m.installFixtures(); start(); });
} else {
  start();
}
